export default "__VITE_ASSET__BI$bL4KE__";